import { Disclosure, DisclosureContent, useDisclosureStore, useStoreState } from '@ariakit/react';
import { Spindown } from '#components/atoms/spindown/Spindown.tsx';
import { ConfigOverrideValue } from '#components/patterns/config-overrides/ConfigOverrideValue.tsx';
import { CONFIG_OVERRIDE_LABELS } from '#components/patterns/config-overrides/labels/ConfigOverrideLabels.ts';
import { DetailList } from '#components/patterns/detail-list/DetailList.tsx';
import { DetailListRow } from '#components/patterns/detail-list/DetailListRow.tsx';
import type { OverridePlusSource } from '../../hooks/useOverrideMaps.ts';
import styles from './StatsDisclosure.module.css';

type Props = {
  type?: OverridePlusSource;
  firstHalf: OverridePlusSource[];
  secondHalf: OverridePlusSource[];
};

export function StatsDisclosure({ type, firstHalf, secondHalf }: Props) {
  const disclosure = useDisclosureStore();
  const isOpen = useStoreState(disclosure, 'open');

  if (!type) {
    return null;
  }

  return (
    <>
      <Disclosure store={disclosure} className={styles.StatsDisclosure_disclosure}>
        <Spindown isExpanded={isOpen} className={styles.StatsDisclosure_spindown} />{' '}
        <DetailList>
          <DetailListRow
            label="Stats type"
            value={<ConfigOverrideValue configOverride={type.value} source={type.source} />}
            labelClassName={styles.StatsDisclosure_disclosureRowLabel}
          />
        </DetailList>
      </Disclosure>

      <DisclosureContent store={disclosure}>
        <div className={styles.StatsDisclosure_tables}>
          <DetailList>
            {firstHalf.map(({ value: statOverride, source }) => (
              <DetailListRow
                key={statOverride.key}
                label={CONFIG_OVERRIDE_LABELS[statOverride.key]}
                value={<ConfigOverrideValue configOverride={statOverride} source={source} />}
                labelClassName={styles.StatsDisclosure_tableRowLabel}
              />
            ))}
          </DetailList>
          <DetailList>
            {secondHalf.map(({ value: statOverride, source }) => (
              <DetailListRow
                key={statOverride.key}
                label={CONFIG_OVERRIDE_LABELS[statOverride.key]}
                value={<ConfigOverrideValue configOverride={statOverride} source={source} />}
                labelClassName={styles.StatsDisclosure_secondColumntableRowLabel}
              />
            ))}
          </DetailList>
        </div>
      </DisclosureContent>
    </>
  );
}
